//import { baseClientUrl } from './staticValues';

export const msalConfig = {
  auth: {
    clientId: '2d03bfae-a7d7-44c2-aa84-5da3328ccc80',
    authority: 'https://login.microsoftonline.com/gennet.onmicrosoft.com',
    redirectUri: process.env.CLIENT_URL,
  },
  cache: {
    cacheLocation: 'localStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
};

//Depricated: can probably remove but have left in for now.
// Add here scopes for id token to be used at MS Identity Platform endpoints.
// export const loginRequest = {
//   scopes: ['2d03bfae-a7d7-44c2-aa84-5da3328ccc80/.default'],
//   forceRefresh: false, // Set this to "true" to skip a cached token and go to the server to get a new token
// };

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const apiRequest = {
  scopes: ['api://1bc8d259-ab38-4a6b-900f-b1d45b48a3b9/post2.read'],
  forceRefresh: true, // Set this to "true" to skip a cached token and go to the server to get a new token
};
export const graphRequest = {
  scopes: ['https://graph.microsoft.com/Calendars.Read'],
  forceRefresh: true, // Set this to "true" to skip a cached token and go to the server to get a new token
};
